import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { App as AntdApp, ConfigProvider } from 'antd';
import viVN from 'antd/locale/vi_VN';
import dayjs from 'dayjs';
import 'dayjs/locale/vi';
import store from 'redux/configure-store';
import { antdTheme } from 'theme/antd-theme';
import App from './App';

// Lịch, phân trang, "Không có dữ liệu"... của antd hiện tiếng Việt.
dayjs.locale('vi');

// ~200 chỗ gọi notification.* / message.* / Modal.confirm dạng tĩnh không đọc được
// ConfigProvider bên dưới → cấp theme + tiếng Việt cho chúng tại đây (antd ≥ 5.13).
ConfigProvider.config({
  holderRender: (children) => (
    <ConfigProvider theme={antdTheme} locale={viVN}>
      {children}
    </ConfigProvider>
  ),
});

// React 18: createRoot (ReactDOM.render cũ làm app chạy ở chế độ React 17 và báo lỗi console).
createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <ConfigProvider theme={antdTheme} locale={viVN}>
          <AntdApp>
            <App />
          </AntdApp>
        </ConfigProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
